import { useCallback } from 'react'
import { useHomeTabStore } from '~/stores/homeTab/homeTab'
import { useIndicatedIssueLabelsCacheStore } from '~/stores/indicatedIssueLabelsCache/indicatedIssueLabelsCache'
import { useLanguageStore } from '~/stores/language/language'
import { useOfflineModeStore } from '~/stores/offlineMode/offlineMode'
import { useUserPlaceNodeStore } from '~/stores/place/place'
import { useSessionStore } from '~/stores/session/session'

/**
 * zustandでpersistしているデータをまとめてクリアする。
 * ログアウト時に加えて、ログイン中に重ねてログインされることを考慮しログイン時にも呼び出す想定。
 *
 * @returns
 */
export const useClearAllPersistedData = () => {
  const logoutOfflineMode = useOfflineModeStore(
    state => state.logoutOfflineMode,
  )
  const logoutSession = useSessionStore(state => state.logout)
  const logoutUserPlaceNode = useUserPlaceNodeStore(state => state.logout)
  const logoutHomeTab = useHomeTabStore(state => state.logoutHomeTab)
  const logoutLanguage = useLanguageStore(state => state.logoutLanguage)
  const logoutIndicatedIssueLabelsCache = useIndicatedIssueLabelsCacheStore(
    state => state.logoutIndicatedIssueLabelsCache,
  )

  const clearAllPersistedData = useCallback(() => {
    logoutSession()
    logoutUserPlaceNode()
    logoutOfflineMode()
    logoutHomeTab()
    logoutLanguage()
    logoutIndicatedIssueLabelsCache()
  }, [
    logoutOfflineMode,
    logoutSession,
    logoutUserPlaceNode,
    logoutHomeTab,
    logoutLanguage,
    logoutIndicatedIssueLabelsCache,
  ])

  return { clearAllPersistedData }
}
